import bTooltip from './tooltip';
import { registerDirectives, vueUse } from '../../utils/plugins';

var directives = {
  bTooltip: bTooltip
};

var VuePlugin = {
  install: function install(Vue) {
    registerDirectives(Vue, directives);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/tooltip/index.js
// module id = 705
// module chunks = 0